import React, { useContext, useEffect, useState } from 'react'
import { DASHBOARD_SIDEBAR_LINKS } from '../../lib/consts/navigation'
import { Link, useLocation } from 'react-router-dom'
import classNames from 'classnames'
import { HiX } from 'react-icons/hi'
import ASCLOGO from '../../assets/asc-logo.jpg'
import { UserContext } from '../../helper/routes/UserContext'

const linkClass =
    'flex items-center gap-3 px-3 py-2 transition-colors duration-150 rounded-lg text-sm font-medium hover:bg-red-50 hover:text-red-700'

export default function Sidebar({ open = false, onClose = () => {} }) {
    const { userRole } = useContext(UserContext)
    const { pathname } = useLocation()
    const [filteredLinks, setFilteredLinks] = useState([])

    useEffect(() => {
        const links = DASHBOARD_SIDEBAR_LINKS.filter((category) => category.roles.includes(userRole))
        setFilteredLinks(links)
    }, [userRole])

    // Close the mobile drawer whenever the route changes
    useEffect(() => {
        onClose()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pathname])

    return (
        <>
            {/* Backdrop, mobile only */}
            {open && (
                <div
                    className="fixed inset-0 z-40 bg-gray-900/40 lg:hidden"
                    onClick={onClose}
                    aria-hidden="true"
                />
            )}

            <aside
                className={classNames(
                    'w-72 sm:w-64 shrink-0 bg-white border-r border-gray-200 flex flex-col text-gray-700',
                    'fixed inset-y-0 left-0 z-50 transform transition-transform duration-200 ease-in-out',
                    'lg:static lg:z-auto lg:translate-x-0',
                    open ? 'translate-x-0' : '-translate-x-full'
                )}
            >
                <div className="flex items-center justify-between px-4 pt-4 lg:justify-center">
                    <div
                        className="h-16 w-40 bg-no-repeat bg-center bg-contain"
                        style={{ backgroundImage: `url(${ASCLOGO})` }}
                    />
                    <button
                        type="button"
                        onClick={onClose}
                        className="p-2 rounded-lg text-gray-400 hover:bg-gray-100 hover:text-gray-600 lg:hidden"
                        aria-label="Close menu"
                    >
                        <HiX className="text-xl" />
                    </button>
                </div>

                {/* Navigation */}
                <nav className="flex-1 overflow-y-auto px-3 py-6">
                    {filteredLinks.map((category) => (
                        <div key={category.key} className="mb-6">
                            <h4 className="px-3 text-xs font-medium text-gray-400 uppercase tracking-widest mb-2">
                                {category.label}
                            </h4>
                            <ul className="space-y-0.5">
                                {category.links.map((item) => (
                                    <SidebarLink key={item.key} item={item} />
                                ))}
                            </ul>
                        </div>
                    ))}
                </nav>

                {/* Footer */}
                <footer className="mt-auto px-4 py-4 border-t border-gray-200 text-[11px] text-gray-400 text-center">
                    ASC Portal Management System &copy; 2024
                </footer>
            </aside>
        </>
    )
}

function SidebarLink({ item }) {
    const { pathname } = useLocation()
    const isActive = pathname === item.path

    return (
        <li>
            <Link
                to={item.path}
                className={classNames(
                    linkClass,
                    isActive ? 'bg-red-50 text-red-700' : 'text-gray-600 hover:text-red-700'
                )}
            >
                <span className="text-base">{item.icon}</span>
                <span className="text-sm">{item.label}</span>
            </Link>
        </li>
    )
}
